import { ActivePopUp } from '../../../interfaces/interfaceInventory';
import { InputComponent } from '../../../components/InputComponent';
import { IInventoryProvider } from '../../../interfaces/service/InventoryServiceManagerInterface';

import { PopUpComponent } from '../../../components/PopUpComponent';

interface IDisableSamProps {
  serviceInventory: IInventoryProvider;
}

export const ModifyDisableSam = (props: IDisableSamProps) => {
  const { serviceInventory } = props;

  const bodyContent = () => {
    return (
      <div className="w-full h-full flex p-6 justify-center">
        <InputComponent
          type="text"
          name="Comentarios"
          placeholder="Observaciones"
          label="Observaciones"
          value={serviceInventory.disableSamValue}
          onChange={serviceInventory.onDisableSamValueChange}
        />
      </div>
    );
  };

  return (
    <PopUpComponent
      header={
        serviceInventory.samInfo?.SamStatus === 'Activar'
          ? '¿Deseas inactivar este Sam?'
          : '¿Deseas activar este Sam?'
      }
      showPopUp={
        serviceInventory.activePopUp === ActivePopUp.DisableSam &&
        serviceInventory.showPopUp
      }
      onSubmit={() => serviceInventory.onModifyDisableSam()}
      onClosePopUp={() => serviceInventory.closePopUp()}
      body={bodyContent()}
      footer={true}
    />
  );
};
